<!-- 商品详情 -->
<template>
<div>
  <Sku
    v-model="isShow"
    stepper-title="兑换数量"
    :sku="sku"
    :goods="goods"
    :goods-id="goodsId"
    :quota="quota"
    :quota-used="quotaUsed"
    :hide-stock="sku.hide_stock"
    show-add-cart-btn
    reset-stepper-on-hide
    :initial-sku="initialSku"
    :preview-on-click-image="false"
    @open-preview="open_preview"
    @stepper-change="buy_num"
  >

    <!-- 自定义 sku-header-price -->
    <template #sku-header-price="props">
      <div class="van-sku__goods-price">
        <span class="van-sku__price-num">{{ props.price }}</span>
        <span class="van-sku__price-symbol">积分</span>
      </div>
    </template>

    <!-- 自定义 sku-body-top -->
    <template #sku-body-top="props">
      <div class="van-sku-group-container">
        <div class="van-sku-row van-hairline--bottom" v-if="goods_data.desc">
          <div class="van-sku-row__title">{{goods_data.desc}}</div>
        </div>

        <div class="van-sku-row van-hairline--bottom">
          <div class="van-sku-row__title">兑换期限{{goods_data.expired_date}}天</div>
        </div>
        <div class="van-sku-row van-hairline--bottom">
          <div class="van-sku-row__title">可用站点</div>
          <span class="van-sku-row__item" v-for="(item, index) in ky_site" :key="index" @click="go_detail(goods_data.s_id[index])">
            <div class="van-sku-row__item-name">{{item}}</div>
          </span>
        </div>
        <div class="van-sku-row van-hairline--bottom">
          <div class="van-sku-row__title">选择油卡：<span class="van-sku-row__title-multiple">（可多选）</span></div>
          <CheckboxGroup v-if="cards.length>0" v-model="selCards" direction="horizontal"  class="van-sku-row__item-name" @change="sel_card">
            <Checkbox :name="item.card_id" class="van-sku-row__item-name" v-for="(item, index) in cards" :key="index">卡号：{{item.card_no}} | <span style="color:red">{{item.inte}} 积分可用</span></Checkbox>
          </CheckboxGroup>
          <van-loading size="24px" v-else>加载中...</van-loading>
        </div>
      </div>
    </template>

    <!-- 自定义 sku actions -->
    <template #sku-actions-top="props">
      <div class="van-sku-header-item text-center" style="text-align:center">
        <span v-if="selCards.length<=0">合计{{totalInte}}积分，请选择需要消耗积分的油卡</span>
        <span v-if="selCards.length>0 && selCardInte<totalInte">已选 {{selCardInte}} 积分，还需 {{totalInte-selCardInte}} 积分</span>
        <span v-if="selCards.length>0 && selCardInte>=totalInte">合计消耗{{totalInte}}积分</span>
      </div>
    </template>

    <!-- 自定义 sku actions -->
    <template #sku-actions="props">
      <div class="van-sku-actions">
        <van-button square size="large" type="warning" @click="onPointClicked" :loading="ifOn" loading-text="兑换中...">
          积分兑换
        </van-button>
      </div>
    </template>

  </Sku>
  <siteDetails ref="details" />
</div>

</template>
<style lang="scss" scoped>
</style>
<script>
import { Sku, Checkbox, CheckboxGroup, ImagePreview } from 'vant'
import siteDetails from '@/components/site/site_details'

export default {

  name: 'store_details',
  components: {Sku, Checkbox, CheckboxGroup, ImagePreview, siteDetails},
  data () {
    return {
      ifOn: false,
      isShow: false,
      site: [],
      ky_site: [],
      cards: [],
      selCards: [],
      selCardsId: [],
      selCardInte: 0, // 选中卡的积分
      totalInte: 0, // 合计需要消耗的积分
      buyNum: 1, // 够买数量
      sku: {
        tree: [],
        // 所有 sku 的组合列表，比如红色、M 码为一个 sku 组合，红色、S 码为另一个组合
        list: [],
        price: '', // 默认价格（单位元）
        stock_num: 0, // 商品总库存
        none_sku: false, // 是否无规格商品
        hide_stock: false // 是否隐藏剩余库存
      },
      goodsId: 0,
      quota: 0,
      quotaUsed: 0,
      goods: {
        // 默认商品 sku 缩略图
        picture: ''
      },
      goods_data: {},
      goods_img: [],
      initialSku: {
        // 键：skuKeyStr（sku 组合列表中当前类目对应的 key 值）
        // 值：skuValueId（规格值 id）
        // 初始选中数量
        selectedNum: 1
      }
    }
  },
  methods: {
    show (goods) {
      this.get_card()
      this.get_site()
      this.selCards = []
      this.selCardsId = []
      this.totalInte = goods.inte
      this.goodsId = goods.id
      this.isShow = true
      this.sku.price = goods.inte
      this.sku.stock_num = goods.issue_num
      this.goods.picture = goods.img_data.length > 0 ? goods.img_data[0].url : ''
      this.goods_img = []
      this.goods_data = goods
      this.ky_site = goods.site_data.split(' | ')
      if (goods.img_data.length > 0) {
        goods.img_data.forEach((item, i) => {
          this.goods_img.push(item.url)
        })
      }
    },

    // 点击兑换
    onPointClicked () {
      if (this.totalInte > this.selCardInte) {
        this.$notify({ type: 'warning', message: '所选油卡积分不足' })
        return false
      }

      let postData = {
        gr_id: this.goodsId,
        buy_num: this.buyNum,
        sel_card: this.selCardsId
      }
      this.ax(this, 'user_goods_into', postData, (res) => {
        if (res.err_num === 0) {
          this.isShow = false

          this.$notify({ type: 'success', message: '兑换成功,请使用兑换券前往油站兑换实物' })
        } else {
          this.$notify({ type: 'warning', message: res.msg })
        }
      }, 'on')
    },

    // 点击跳转站点详情
    go_detail (id) {
      let site = null
      this.site.forEach((item) => {
        if (item.s_id === id) {
          site = item
        }
      })
      if (site !== null) {
        this.$refs.details.show(site)
      }
    },

    // 获取卡数据数据
    get_card () {
      this.cards = []
      this.ax(this, 'sel_web_card_user', {}, (res) => {
        if (res.err_num === 0) {
          this.cards = res.data.card_data
        }
      }, false)
    },

    // 获取油站
    get_site () {
      this.ax(this, 'sel_site', {set_price: false}, (res) => {
        if (res.err_num === 0) {
          this.site = res.data
        }
      })
    },

    // 选择够买数量
    buy_num (num) {
      this.buyNum = num
      this.totalInte = parseInt(num) * parseInt(this.goods_data.inte)
    },

    // 选择油卡
    sel_card () {
      this.selCardInte = 0
      this.selCardsId = []
      if (this.selCards.length > 0) {
        this.selCards.forEach((selCardId, i) => {
          this.cards.forEach((card, j) => {
            if (selCardId === card.card_id) {
              this.selCardsId.push(card.card_id)
              this.selCardInte += parseInt(card.inte)
            }
          })
        })
      }
    },

    // 打开封面图
    open_preview () {
      if (this.goods_img.length > 0) {
        ImagePreview(this.goods_img)
      } else {
        this.$notify({ type: 'warning', message: '暂无图片' })
      }
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/inte_store/store_details.vue